import { render, staticRenderFns } from "./EducationalQualificationDetailsContent.vue?vue&type=template&id=4af13d90&scoped=true"
import script from "./EducationalQualificationDetailsContent.vue?vue&type=script&lang=ts"
export * from "./EducationalQualificationDetailsContent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af13d90",
  null
  
)

export default component.exports